import React from 'react';
import { tomos } from '../data/content';
export function Contents() {
  return <section id="contenido" className="w-full bg-cream-50 py-16 lg:py-24" data-id="element-26" data-mp="or1gtz53ptme">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-27" data-mp="osumpc7w49tc">
        <div className="max-w-2xl" data-id="element-28" data-mp="12rkkyv6g4fja">
          <p className="font-display text-sm font-bold text-gold-600" data-id="element-29" data-mp="12og9rdukcjj4">
            Qué incluye
          </p>
          <h2 className="display-tight mt-4 font-display text-4xl font-extrabold text-forest-800 sm:text-5xl" data-id="element-30" data-mp="xtswkb50fbju">
            6 tomos, un solo sistema.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-forest-700/80" data-id="element-31" data-mp="17ouhsvw5zth5">
            Cada tomo se aplica en el mismo mes que lo leés. Sin teoría de más,
            sin promesas raras: tareas concretas y planillas listas.
          </p>
        </div>

        <ol className="mt-12 divide-y divide-cream-200 border-t border-cream-200" data-id="element-32" data-mp="1veyo5b0qm7bu">
          {tomos.map(tomo => <li key={tomo.n} className="grid gap-2 py-7 sm:grid-cols-[auto_1fr_1.2fr] sm:items-baseline sm:gap-8" data-id="element-33" data-mp="1qgwtdsty8jkj">
              <span className="font-display text-2xl font-extrabold text-gold-600 sm:w-14" data-id="element-34" data-mp="1ftsoy8ij2u68">
                {tomo.n}
              </span>
              <h3 className="font-display text-xl font-bold text-forest-800" data-id="element-35" data-mp="1orwdldot8729">
                {tomo.title}
              </h3>
              <p className="leading-relaxed text-forest-700/80" data-id="element-36" data-mp="1tsa9xyh1tskg">{tomo.copy}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}